import { render, staticRenderFns } from "./EditUSerAdmin.vue?vue&type=template&id=0608871c&"
import script from "./EditUSerAdmin.vue?vue&type=script&lang=js&"
export * from "./EditUSerAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports